/**
 * The style dial for a section that had none of its own: its usual look, or
 * bold. Bold sets the section heading in heavy capitals and gives the section
 * its bold treatment, so every section on a bold page matches. One definition,
 * so every section offers the same two words; a section with its own style
 * dial (Hero, Services, Gallery, Contact Form) adds "bold" to that instead.
 */
const SectionStyleField = {
  type: "radio",
  label: "Style",
  options: [
    { label: "Standard", value: "standard" },
    { label: "Bold", value: "bold" },
  ],
  metadata: {
    source: "manual",
    description: "Bold sets the heading in big capitals, to match the other bold sections on the page.",
  },
} as const;

/** The values of the shared section style dial. */
type SectionStyle = (typeof SectionStyleField)["options"][number]["value"];

/**
 * A section's background: the page's own light ground, or a dark band in the
 * theme's primary colour with light type on it. One definition, so every
 * section that offers it uses the same two words. Alternating the two keeps a
 * long page from reading as one flat run of sections.
 */
const SectionToneField = {
  type: "radio",
  label: "Background",
  options: [
    { label: "Light", value: "light" },
    { label: "Dark", value: "dark" },
  ],
  metadata: {
    source: "manual",
    description: "Dark sets the section on a dark band with light type, to break up a long light page.",
  },
} as const;

/** The values of the shared section background dial. */
type SectionTone = (typeof SectionToneField)["options"][number]["value"];

export type { SectionStyle, SectionTone };
export { SectionStyleField, SectionToneField };
